document.addEventListener('DOMContentLoaded', () => {
	const body = document.body
	const collapsable = document.querySelector('.more-breadcrumbs-wrapper')

	if (collapsable) {
		const more = collapsable.querySelector('#more-breadcrumbs')
		const trigger = collapsable.querySelector('[role="button"]')

		if (more && trigger) {
			// You might notice this looks very similar to the collapsible.js code and wonder:
			// "Why didn't she just make the HTML fit the structure to tap into that existing JavaScript?"
			// I did do that--at first;
			// then I realized it might be confusing to have some of the functionality for
			// collapsable breadcrumbs in one file
			// and the rest in another;
			// so I completely disconnected them.
			// Plus, this way we're not measuring the height of the breadcrumbs box unnecessarily.
			trigger?.addEventListener('click', () => {
				trigger.setAttribute(
					'aria-expanded',
					trigger.getAttribute('aria-expanded') === 'false',
				)
				more.toggleAttribute('hidden')
				hideOrShowAllInteractiveItems(more)
			})

			trigger?.addEventListener('keydown', e => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault()
					trigger.setAttribute(
						'aria-expanded',
						trigger.getAttribute('aria-expanded') === 'false',
					)
					more.toggleAttribute('hidden')
					hideOrShowAllInteractiveItems(more)
				}
			})

			// Click-off functionality
			window.addEventListener('click', e => {
				const target = e.target
				if (!target.closest('.more-breadcrumbs-wrapper')) {
					trigger.setAttribute('aria-expanded', 'false')
					more.setAttribute('hidden', 'true')
				}
			})

			let minWidth = 300
			let maxWidth = 400
			let targetLeft = 0
			function calculatePosition() {
				let boundingRect = more.getBoundingClientRect()
				let leftPropVal = parseFloat(more.style.getPropertyValue('left') || 0)

				// First - Check if right side is off screen
				if (boundingRect.right > body.clientWidth) {
					// If so, calculate width adjustment necessary to stop the cutting
					let changeWidth = boundingRect.right - body.clientWidth
					let targetWidth = boundingRect.width - changeWidth
					// Check if new width would be greater than our established minimum
					if (targetWidth > minWidth) {
						// If so, set width
						more.style.setProperty('width', `${targetWidth}px`)
					} else {
						// If not, set width to established minimum
						more.style.setProperty('width', `${minWidth}px`)
						// Set left to difference between target width and min width plus current left property value
						more.style.setProperty(
							'left',
							`${leftPropVal + (targetWidth - minWidth)}px`,
						)
					}
				} else {
					// If not, check if left property value is < our target
					if (leftPropVal < targetLeft) {
						// If so, check how much we can adjust by
						let changeLeft = body.clientWidth - boundingRect.right
						// Set maxLeft we could get away with given our available space
						let maxLeft = leftPropVal + changeLeft
						// Adjust left (make sure we don't exceed the target value, though)
						more.style.setProperty('left', `${Math.min(targetLeft, maxLeft)}px`)
					} else {
						// If not, check if width is less than established maximum
						if (boundingRect.width < maxWidth) {
							// If so, check how much we can increase the width by
							let changeWidth = body.clientWidth - boundingRect.right
							// Set our target width
							let targetWidth = boundingRect.width + changeWidth
							// Set the width (make sure we don't exceed maxWidth, though)
							more.style.setProperty(
								'width',
								`${Math.min(targetWidth, maxWidth)}px`,
							)
						}
					}
				}
			}

			window.addEventListener('resize', () => {
				calculatePosition()
			})

			function hideOrShowAllInteractiveItems(parentEl, mode = 'auto') {
				// a list of selectors for all focusable elements.
				const focusableItems = [
					'a[href]',
					'area[href]',
					'input:not([disabled])',
					'select:not([disabled])',
					'textarea:not([disabled])',
					'button:not([disabled])',
					'[tabindex]:not([disabled])',
					'[contenteditable=true]:not([disabled])',
				]

				// build a query string that targets the parent div ID and all children elements that are in our focusable items list.
				let queryString = focusableItems.join(', ')
				queryString = queryString.replace(/,\s*$/, '')

				let focusableElements = parentEl.querySelectorAll(queryString)
				for (let j = 0, lenj = focusableElements.length; j < lenj; j++) {
					let el = focusableElements[j]
					// we use the 'data-modified' attribute to track all items that we have applied a tabindex to (as we can't use tabindex itself).
					if (!el.hasAttribute('data-modified') || mode == 'force-hide') {
						// we haven't modified this element so we grab the tabindex if it has one and store it for use later when we want to restore.
						if (el.hasAttribute('tabindex')) {
							el.setAttribute('data-oldTabIndex', el.getAttribute('tabindex'))
						}
						el.setAttribute('data-modified', true)
						el.setAttribute('tabindex', '-1') // add `tabindex="-1"` to all items to remove them from the focus order.
					} else {
						// we have modified this item so we want to revert it back to the original state it was in.
						el.removeAttribute('tabindex')
						if (el.hasAttribute('data-oldtabindex')) {
							el.setAttribute('tabindex', el.getAttribute('data-oldtabindex'))
							el.removeAttribute('data-oldtabindex')
						}
						el.removeAttribute('data-modified')
					}
				}
			}

			// Run this once on page load in case the box is already cut off on the current screen size
			calculatePosition()

			// Run this automatically on page load to hide any tabbable elements
			hideOrShowAllInteractiveItems(more, 'force-hide')
		}
	}
})
